import maNavbarCategory from '@/components/navbarCategories'
import buttonBotton from '@/components/button-blue'
import { mapState, mapActions, mapMutations } from 'vuex'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_SINISTER_SUMMARY,
  WARRANTY_DELETE_DAMAGE,
  UPDATE_CART_IS_ACTIVE
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'

export default {
  name: 'damagesConfirmed',

  mixins: [flowMixin, userFlowMixin],

  components: {
    maNavbarCategory,
    buttonBotton
  },

  data: function () {
    return {
      damagesDetails: [],
      title: '',
      showCartDetail: false,
      damageId: null,
      showDeleteBtn: false,
      mursQuantity: null,
      literalEvaluePar: '',
      titleBienesImobCategory: '',
      surfaceInfo: {
        key: '',
        literal: ''
      },
      damageDetailsLength: false
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterSummary: 'sinisterSummary'
    }),

    ...mapState({
      stateCartIsActive: (state) => state.cartIsActive
    }),

    getBtnType() {
      return this.stateCartIsActive
        ? 'onlyFunctionalBtnWhite'
        : 'functionalBtnWhite'
    },

    flowName() {
      return this.getUserFlow
    },
    damageImagesLength() {
      return this.damagesDetails?.images?.length || 0
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetSinisterSummary: WARRANTY_GET_SINISTER_SUMMARY,
      actWarrantyDeleteDamage: WARRANTY_DELETE_DAMAGE
    }),

    ...mapMutations({
      updateCartIsActive: UPDATE_CART_IS_ACTIVE
    }),

    /**
     * If the router param - damage id is greater then 1 it will search for that damage and display its details also filters it
     */
    filterSinisterDamagesSumary() {
      if (this.$route.params.damageId >= 1) {
        this.showCartDetail = true
        this.damageId = this.$route.params.damageId
        const targetDamage = this.stateWarrantySinisterSummary.find(
          (damage) =>
            parseInt(damage.damage_id) === parseInt(this.$route.params.damageId)
        )
        this.damagesDetails = targetDamage
        this.addMursQty()
        this.removeSurfaceDetails()
      }
    },

    /**
     * Gets the list with all the images and bases on its name it returns a list for each name
     */
    getImageSrc(imgName, imgList) {
      let imgSrc = []
      if (imgList) {
        imgList.forEach((img) => {
          if (img.imageType === imgName || img.imageType === 'photoClaimFlow') {
            imgSrc.push(img.imageContent)
          }
        })
      }
      return imgSrc
    },

    /**
     * If there is any damage with the title mur, it pushes an object into the damage details to reflect the number of murs damaged
     */
    addMursQty() {
      if (
        this.damagesDetails.selfcare_title.toUpperCase().indexOf('MUR') !== -1
      ) {
        let objMurs = {
          key: 'Nombre de murs touchés',
          literal: this.damagesDetails.selfcare_title.substring(0, 1)
        }
        this.damagesDetails.details.push(objMurs)
      }
    },

    /**
     * Removes the surface details from all the damages that cointain it and pushes one object to reflect it only oance for all the category
     */
    removeSurfaceDetails() {
      // surface qty

      this.damagesDetails.details.forEach((detail, ind) => {
        if (detail.literal.indexOf('m²') !== -1) {
          this.titleBienesImobCategory = this.damagesDetails.selfcare_subtitle
          this.literalEvaluePar = detail.key
          this.damagesDetails.details.splice(ind, 1)
          this.surfaceInfo.key = 'Surface du salon (en mètres carrés)'
          this.surfaceInfo.literal = detail.literal.replace(' m²', '')
        }
      })

      // evalue par surface
      this.damagesDetails.details.forEach((detail, ind) => {
        if (detail.literal === this.literalEvaluePar) {
          this.damagesDetails.details.splice(ind, 1)
        }
      })
    },

    /**
     * If the damage title exists and the caegory is bienesImobilieres it will show whe surface detail in the damage details
     */
    surfaceIsVisible(titleCategory) {
      return titleCategory &&
        this.surfaceInfo &&
        this.titleBienesImobCategory === titleCategory
    },

    getSubtitle(subtitle) {
      if (subtitle && subtitle.toUpperCase().indexOf('MUR') !== -1) {
        this.mursQuantity = subtitle.substring(0, 1)
        return 'Murs'
      } else {
        return subtitle
      }
    },

    handleClickAcceptDamages() {
      this.goBack()
    },

    handleClickReviseDamages() {
      const damagesViewViewName = 'damages-view'
      this.goToView(damagesViewViewName)
    },

    /**
     * Deletes the damage and goes back to the damages view
     */
    handleDeleteDamage() {
      const damageId = this.damageId
      const sinisterId = this.getSinisterId
      this.actWarrantyDeleteDamage({ damageId, sinisterId }).then(() => {
        this.showDeleteBtn = false
        this.handleClickReviseDamages()
      })
    }
  },

  /**
   * If the damage id changes it will get the data damages and uptate the damage details
   */
  watch: {
    damageId(value) {
      this.damageId = value
      const sinisterId = this.getSinisterId
      this.actWarrantyGetSinisterSummary(sinisterId).then(() => {
        this.filterSinisterDamagesSumary()
      })
    },
    damagesDetails(value) {
      this.damageDetailsLength = value && value.details.length > 0
    }
  },

  /**
   * Executes the actWarrantyGetSinisterSummary and sets the damages data list
   */
  mounted() {
    // Notify Vue App of the current active element in screen
    this.notifyAppOfChanges(this)

    const sinisterId = this.getSinisterId
    this.actWarrantyGetSinisterSummary(sinisterId).then(() => {
      this.filterSinisterDamagesSumary()
    })
  },

  beforeDestroy: function () {
    this.updateCartIsActive(false)
  }
}
